import { getUser } from 'localStorage/authStorage';
import { CompanyRole } from 'models/companies/enums/companies.enums';
import { UserType } from '../enums/user-management.enum';

export const isAdminUser = (): boolean => {
	const user = getUser();
	if (!user) return false;

	return (
		user.type === UserType.ADMIN && user.company?.role === CompanyRole.ADMIN
	);
};
